import { oneOf, string, object } from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';

import { Spinner } from 'components/blueprint';

/**
 * LoadingSpinner
 * A circular spinner
 */
export const LoadingSpinner = ({
  variant = 'light.small',
  label,
  bottomLoader = false,
  wrapperSx = {},
  loaderSx = {},
  spinnerProps = {},
  ...rest
}) => {
  return (
    <Flex
      sx={{
        ...wrapperSx,
      }}
      {...rest}
    >
      <Box
        sx={{
          position: 'absolute',
          ...loaderSx,
        }}
      >
        <Spinner label={label} variant={variant} {...spinnerProps} />
      </Box>
    </Flex>
  );
};

LoadingSpinner.propTypes = {
  /**
   * Sets the spinner variant
   */
  variant: oneOf(['light.small', 'light.medium']),
  /**
   * Sets the label (if required)
   */
  label: string,
  /**
   * Sets the sx for the loading wrapper (if required)
   */
  wrapperSx: object,
  /**
   * Sets the sx for the loading component (if required)
   */
  loaderSx: object,
};
